<template>
  <div>
    <div class="d-flex flex-row align-center mx-6">
      <v-btn icon class="d-md-none" @click="drawer = true"><v-icon>mdi-menu</v-icon></v-btn>
      <!-- <v-avatar size="48" class="ma-3 pointer" @click="go('LandingView')"> -->
      <img src="../assets/logo.png" class="ma-3 pointer" @click="go('LandingView')" width="38" height="38">
      <!-- </v-avatar> -->
      <!-- <v-avatar v-else size="48" class="ma-3 pointer" @click="go('LandingView')" color="red"></v-avatar> -->
      <h1 class="cal-sans-regular pointer" @click="go('LandingView')">IDEAVERSE</h1>
      <!-- <h1 v-else class="cal-sans-regular pointer" @click="go('LandingView')">DONKEYBALL</h1> -->
      <div class="mb-3">&trade;</div>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="primary"
        class="d-none d-md-flex ml-10 width-auto"
        :hide-slider="true"
      >
        <v-tab class="d-none"></v-tab>
        <v-tabs-slider :color="menu[tab-1]?.colour || 'secondary'"></v-tabs-slider>
        <v-tabs-slider v-if="tab == 6" color="red"></v-tabs-slider>
        <v-tab v-for="(item, index) in menu" :key="'menu-item-' + index" @click="go(item.route)" color="red">
          <span
            class="font-size-16"
            :class="item.routes.includes($route.name) && item.textClass ? item.textClass + ' font-weight-bold' : 'black--text'"
          >{{ item.name }}</span>
        </v-tab>
      </v-tabs>

      <v-spacer></v-spacer>

      <!-- ------------ Not Authenticated ------------ -->
      <v-btn v-if="!authUser" color="secondary" class="black--text elevation-0 mr-3" @click="go('LoginView')">Get Started</v-btn>

      <!-- ------------ Authenticated ------------ -->
      <!-- <v-btn v-if="authUser" color="secondary" class="black--text elevation-0 mr-3" @click="go('RealmDashboard')">Create</v-btn> -->
      <strong v-if="authUser && profile && profile.username" class="d-none d-lg-inline-block username" :title="profile.username">{{ profile.username }}</strong>
      <div v-if="authUser && profile && profile.sparks !== undefined" class="mr-3 d-none d-lg-flex flex-row align-center">
        <v-icon color="yellow darken-3" large>mdi-star-four-points-small</v-icon>{{ profile.sparks }}
      </div>
      <v-menu v-if="authUser" offset-y min-width="200">
        <template v-slot:activator="{ on, attrs }">
          <v-avatar v-bind="attrs" v-on="on" size="48" class="mr-3">
            <v-img :src="profile && profile.avatar ? profile.avatar : ''"></v-img>
          </v-avatar>
        </template>
        <v-list>
          <v-list-item @click="go('RealmDashboard')">Dashboard</v-list-item>
          <v-list-item @click="go('RealmAccount')">Account</v-list-item>
          <!-- <v-list-item @click="go('RealmGuild')">Guild</v-list-item> -->
          <v-divider></v-divider>
          <v-list-item @click="logout">Logout</v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <div class="d-flex flex-row align-center justify-left pa-4">
        <img src="../assets/logo.png" class="pointer" @click="go('LandingView')" width="38" height="38">
        <h1 class="cal-sans-regular pointer ml-2" @click="go('LandingView')">IDEAVERSE</h1>
        <div class="mb-3">&trade;</div>
      </div>
      <v-divider></v-divider>

      <v-list>
        <v-list-item v-for="(item, index) in menu" :key="'menu-item-' + index" @click="go(item.route)" color="red">
          <v-list-item-title class="text-uppercase font-size-16 font-weight-bold" :class="item.routes.includes($route.name) && item.textClass ? item.textClass : 'black--text'">
            {{ item.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
    <v-progress-linear
      :color="menu.find(item => item.routes.includes($route.name))?.colour || 'grey lighten-3'"
      :value="100"
    ></v-progress-linear>
  </div>
</template>

<script>
import { signOut, getAuth } from 'firebase/auth'
export default {
  name: 'HeaderComponent',

  data() {
    return {
      tab: 0,
      drawer: false,
      menu: [
        {
          name: 'Games',
          route: 'GameLibrary',
          tab: 1,
          colour: 'blue',
          textClass: 'blue--text',
          routes: ['GameLibrary', 'RealmGame'],
        },
        {
          name: 'Stories',
          route: 'StoryLibrary',
          tab: 2,
          colour: 'green',
          textClass: 'green--text',
          routes: ['StoryLibrary', 'RealmStory'],
        },
        {
          name: 'Lessons',
          route: 'LessonLibrary',
          tab: 3,
          colour: 'purple',
          textClass: 'purple--text',
          routes: ['LessonLibrary', 'RealmLesson'],
        },
        {
          name: 'Ideas',
          route: 'IdeaLibrary',
          tab: 4,
          colour: 'yellow darken-3',
          textClass: 'yellow--text text--darken-3',
          routes: ['IdeaLibrary', 'RealmIdea'],
        },
        {
          name: 'Conundrums',
          route: 'ConundrumLibrary',
          tab: 5,
          colour: 'teal',
          textClass: 'teal--text',
          routes: ['ConundrumLibrary', 'RealmConundrum'],
        },
        {
          name: 'Chat',
          route: 'RealmChat',
          tab: 6,
          colour: 'red',
          textClass: 'red--text',
          routes: ['RealmChat'],
        },
      ]
    }
  },

  methods: {
    logout() {
      const auth = getAuth()
      signOut(auth)
      .then(() => {
        this.go('LandingView')
      })
      .catch((error) => {
        console.error(error)
      })
    },
  },

  watch: {
    $route: {
      handler(to) {
        let match = this.menu.find(item => item.route === to.name)
        if (match) this.tab = match.tab
        else this.tab = 0
      },
      immediate: true
    }
  },

  computed: {
    authUser() {
      return getAuth().currentUser;
    },
    profile() {
      return this.$profileStore?.data || {};
    },
    sparks() {
      return this.profile?.sparks || 0
    }
  }
}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .username {
    white-space: nowrap;
  }
</style>